import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import account, { LOGOUT_SUCCESS } from './Account';
import admin from './admin/Admin';
import agingReport from './admin/AgingReport';

import modal from './Modal';
import company from './network/Company';
import uom from './network/UOM';
import currency from './network/Currency';
import paymentTerm from './payment/PaymentTerm';
import tax from './network/Tax';
import branch from './network/Branch';
import purchaseSetup from './network/PurchaseSetup';
import purchaseOrder from './network/PurchaseOrder';
import saleOrder from './network/SaleOrder';
import deliveryOrder from './network/DeliveryOrder';
import notificationMessage from './network/NotificationMessage';
import log from './Log';

import file from './File';
import customer from './customer/Customer';
import potentialAgent from './customer/PotentialAgent';
import cost from './product/Cost';
import dimension from './product/Dimension';
import warranty from './product/Warranty';
import location from './product/Location';
import productCategory from './product/ProductCategory';
import productType from './product/ProductType';
import brand from './product/Brand';
import product from './product/Product';
import movementJournal from './product/MovementJournal';
import agent from './agent/Agent';
import technician from './service/Technician';

import timeslot from './service/Timeslot';
import holiday from './service/Holiday';
import appointment from './service/Appointment';
import membership from './customer/Membership';
import reward from './customer/Reward';
import transaction from './payment/Transaction';
import invoice from './payment/Invoice';
import invoicePDFLog from './payment/InvoicePDFLog';
import creditNote from './payment/CreditNote';
import contract from './payment/Contract';
import serialNumber from './product/ProductSerialNumber';
import setting from './network/Setting';
import serviceMovingJournal from './service/ServiceMovingJournal';
import notification from './admin/Notification';
import dashboard from './admin/Dashboard';
import configuration from './admin/Configuration';
import permission from './admin/Permission';
import bank from './network/Bank';
import city from './network/City';

const appReducer = history =>
  combineReducers({
    form: formReducer,
    router: connectRouter(history),
    account,
    admin,
    agingReport,
    modal,
    file,
    log,
    notification,
    dashboard,
    configuration,
    permission,

    company,
    currency,
    uom,
    paymentTerm,
    branch,
    tax,
    purchaseSetup,
    purchaseOrder,
    saleOrder,
    deliveryOrder,
    setting,

    customer,
    potentialAgent,

    reward,
    city,
    cost,
    dimension,
    warranty,
    location,
    notificationMessage,
    productCategory,
    productType,
    brand,
    product,
    movementJournal,

    agent,
    technician,

    timeslot,
    holiday,
    appointment,
    membership,
    transaction,
    invoice,
    creditNote,
    invoicePDFLog,
    contract,
    serialNumber,
    serviceMovingJournal,
    bank,
  });

const initialState = appReducer({}, {});

const rootReducer = history => (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = initialState;
  }

  return appReducer(history)(state, action);
};

export default rootReducer;
